export default "__VITE_ASSET__BHBXYRmT__"